<template>
  <FreeToolPage v-if="seo" :seo="seo" />
</template>

<script setup>
// #19 ①B 根压缩器:旧 UCard 退役,改新设计(FreeToolPage → ToolStagePlaceholder root="compressor")。
// slug 覆盖为 "compressor"(seo-data) → canonical /free-tools/image/compressor;压缩走前端 canvas 质量重编码。
import { useAsyncData, showError, createError } from "#imports";
import { getToolSEO } from "@/settings/free-tools/seo-data";

definePageMeta({ layout: "free-tools" });

const { data: seo } = await useAsyncData("free-tool-compressor", () => getToolSEO("compressor") ?? null, { default: () => null });

if (!seo.value) {
  showError(createError({ statusCode: 404, statusMessage: "Tool Not Found", fatal: true }));
}

useFreeToolSeoHead(seo);
</script>
